var _rect, _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnCommunity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9066 5.05462L4.4166 10.6618C4.40798 10.6651 4.39962 10.6691 4.3916 10.6737C4.2741 10.7402 3.4541 11.2418 4.61035 11.6915L4.62223 11.6959L8.07254 12.8106C8.09886 12.8191 8.12674 12.8218 8.15421 12.8185C8.18169 12.8151 8.2081 12.8058 8.2316 12.7912L16.7894 7.45181C16.8104 7.43871 16.8338 7.4299 16.8582 7.42587C16.9772 7.40619 17.32 7.36931 17.1032 7.64462C16.8579 7.95712 11.0125 13.1952 10.3638 13.7762C10.3264 13.8098 10.3032 13.8564 10.2991 13.9065L10.016 17.2815C10.0159 17.3159 10.0239 17.3498 10.0393 17.3805C10.0546 17.4113 10.0769 17.4381 10.1044 17.4587C10.1434 17.4833 10.1893 17.4946 10.2353 17.4911C10.2812 17.4877 10.3249 17.4695 10.3597 17.4393L12.4097 15.6071C12.4421 15.5782 12.4834 15.5612 12.5268 15.559C12.5702 15.5568 12.613 15.5695 12.6482 15.5949L16.2247 18.1918L16.2363 18.1996C16.3229 18.2531 17.2579 18.7971 17.5279 17.5821L19.9966 5.84306C20 5.80587 20.0335 5.39712 19.7413 5.15556C19.4344 4.90306 19 5.03056 18.9347 5.04431C18.9251 5.04699 18.9157 5.05044 18.9066 5.05462Z",
    fill: "#262949"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 15.7998,
    r: 2.5,
    fill: "#EA7E68",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCommunity);
export default __webpack_public_path__ + "static/media/icn-community.737301802a3b139482db2b7a3f5e93f7.svg";
export { ForwardRef as ReactComponent };